import SearchFilterComponent from "../../Common/SearchFilterComponent/SearchFilterComponent";
import { Button } from "react-bootstrap";

const ReportSearchFilter = ({
  leftSide,
  searchValue,
  searchOnChange,
  searchOnCross,
  searchInputRef,
  onSortClick,
  onReportClick
}) => {
  return (
    <SearchFilterComponent
      leftSide={leftSide}
      searchValue={searchValue}
      searchOnChange={searchOnChange}
      searchOnCross={searchOnCross}
      passedRef={searchInputRef}
      setRef={() => {
        searchInputRef.current.focus()
      }}
      // passedFilterList={tableFilters}
      // onFilterClick={addFilter}
      // orderData={headersList}
      setOrderData={(e) => {
        // setHeadersList(e);
        // getPageData({
        //   AccountSortVisibility_List: JSON.stringify(e),
        //   ClientNumber: 0,
        // });
      }}
      onSortClick={onSortClick}
      showVisibilityComponent={false}
      lastButtonChild={
        <Button className="hg-blue-btn" onClick={onReportClick}>
          <img alt="plus" width={12} height={12} src={'/images/attack-surface/white-plus.svg'} className="mr-1" />
          New Report
        </Button>
      }
    />
  );
};

export default ReportSearchFilter;

